const initialState = {
  first_name: "",
  last_name: "",
  email: "",
  routing_number: "",
  account_number: "",
  bank_name: "",
  company_name: "",
  brand: "",
  last4: "",
  verified: undefined,
  account_holder_type: undefined,
  account_holder_name: undefined,
  kind: undefined,
  card_number: "",
  errors: [],
  ui: {
    show: false,
    is_submitting: false,
    callback_action: undefined,
  },
};

export default function newPaymentSourceForm(state = initialState, action) {
  switch (action.type) {
    case "SET_NEW_PAYMENT_SOURCE_CALLBACK_ACTION":
      return {
        ...state,
        ui: {
          ...state.ui,
          callback_action: action.payload.callback_action,
        },
      };
    case "UPDATE_NEW_PAYMENT_SOURCE_FORM_UI":
      return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        },
      };
    case "UPDATE_NEW_PAYMENT_SOURCE_FIELD":
      return {
        ...state,
        ...action.payload,
      };
    case "BEGIN_SUBMIT_NEW_PAYMENT_SOURCE":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true,
        },
      };
    case "FAILED_SUBMIT_NEW_PAYMENT_SOURCE":
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          is_submitting: false,
        },
      };
    // case "SUCCESS_SUBMIT_NEW_PAYMENT_SOURCE":
    case "RESET_NEW_PAYMENT_SOURCE_FORM":
      return initialState;
    default:
      return state;
  }
}
